import React from "react";
import { Layout as DashboardLayout } from "../common/Layout/dashboard/layout";
import Login from "../pages/Login";
import Register from "../pages/Register";
import ResetPassword from "../pages/ResetPassword";
import VerifyEmail from "../pages/VerifyEmail";
import UpdatePassword from "../pages/UpdatePassword";
import Page404 from "../pages/404";
import Home from "../pages/Home";
import Demo from "../pages/Demo";
import Business from "../pages/Business/Business";
import AddBusiness from "../pages/Business/Addbusiness";
import Settings from "../pages/Settings";
import Conversations from "../pages/Conversations";
import EditPassord from "../pages/Users/editpassword";
import Client from "../pages/Client";
import NewClient from "../pages/Client/NewClient/index";
import Users from "../pages/Users";
import AddOrEdituser from "../pages/Users/AddOrEdituser/index";
import { routeManifest } from "../access/routeManifest";
import { resolveAccessCapabilities } from "../access/capabilities";

const commonRoutes = [
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/verify",
    element: <VerifyEmail />,
  },
  {
    path: "/update-password",
    element: <UpdatePassword />,
  },
  {
    path: "*",
    element: <Page404 />,
  },
];

export const unauthorizedRoutes = [
  {
    path: "/",
    element: <Login />,
  },
  ...commonRoutes,
];

const dashboardRouteElements = {
  "/": <Home />,
  "/users": <Users />,
  "/add/users": <AddOrEdituser />,
  "/edit/users": <AddOrEdituser />,
  "/user/updatepassword": <EditPassord />,
  "/clients": <Client />,
  "/clients/add": <NewClient />,
  "/clients/editclient": <NewClient />,
  "/business": <Business />,
  "/business/add": <AddBusiness />,
  "/business/edit": <AddBusiness />,
  "/settings": <Settings />,
  "/conversations": <Conversations />,
  "/demo": <Demo />,
};

const getDashboardRouteElement = (path) => {
  const element = dashboardRouteElements[path];

  if (!element) {
    throw new Error(`Missing dashboard route element for path: ${path}`);
  }

  return element;
};

const buildDashboardChildren = (capabilities) =>
  routeManifest
    .filter(({ capability }) => capabilities[capability])
    .map(({ path }) => ({
      path,
      element: getDashboardRouteElement(path),
    }));

const buildAuthenticatedRoutes = (capabilities) => [
  {
    path: "/",
    element: <DashboardLayout />,
    children: buildDashboardChildren(capabilities),
  },
  ...commonRoutes,
];

const getRoutes = (access = {}) => {
  const resolvedCapabilities = resolveAccessCapabilities(access);

  const hasAuthenticatedRoutes = Object.values(resolvedCapabilities).some(
    Boolean
  );

  if (!hasAuthenticatedRoutes) {
    return unauthorizedRoutes;
  }

  return buildAuthenticatedRoutes(resolvedCapabilities);
};

export default getRoutes;
